import React, { useState } from 'react';
import cx from 'classnames';
import BoxBody from 'components/BoxBody';
import EventTracking from 'lib/EventTracking';
import TabPanel from 'components/TabPanel';
import Tabs from 'components/Tabs';

import CoachingConstants from 'coaching/CoachingConstants';
import CoachingCoordinatorNoShowsView from 'coaching/components/CoachingCoordinatorView/CoachingCoordinatorNoShowsView';
import CoachingCoordinatorUnfulfilledView from 'coaching/components/CoachingCoordinatorView/CoachingCoordinatorUnfulfilledView';

import '../styles/CoachingCoordinatorSessionsView.scss';

const className = 'CoachingCoordinatorSessionsView';

export default function CoachingCoordinatorSessionsView() {
  const [activeTab, setActiveTab] = useState(0);

  function tabEventName(tab: number) {
    switch (tab) {
      case 0:
        return 'no_shows_tab';
      case 1:
        return 'unfulfilled_tab';
    }
  }
  return (
    <div className={cx(className, 'CoachingCoordinatorView-content')}>
      <BoxBody size="small" className={`${className}-container`}>
        <Tabs
          className={`${className}-tabs`}
          flush={false}
          onTabChange={(tab: number) => {
            setActiveTab(tab);
            EventTracking.trackKey(
              `${CoachingConstants.COORDINATOR_TOOL_EVENT_PREFIX}.sessions.${tabEventName(
                tab
              )}.click`
            );
          }}
          tabActive={activeTab}>
          <TabPanel title="No shows">
            <CoachingCoordinatorNoShowsView />
          </TabPanel>
          <TabPanel title="Unfulfilled">
            <CoachingCoordinatorUnfulfilledView />
          </TabPanel>
        </Tabs>
      </BoxBody>
    </div>
  );
}
